"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CautionSign = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const tooltip_1 = require("primereact/tooltip");
const CautionSign = (props) => {
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { id: props.id, className: 'm-auto', src: '/cautionSign.svg', width: 25, height: 20, style: { verticalAlign: 'middle' }, "data-pr-tooltip": props.info }), (0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: '#' + props.id })] });
};
exports.CautionSign = CautionSign;
